import {DataRangesEnum} from '../../../models/enum/Date-Ranges.enum';

export default class Utils {
    static getDataRange(validValueItem: string)
    {
        const date = new Date();
        const currQuarter = Math.floor(date.getMonth() / 3 + 1);
        let startDate: Date = new Date();
        let endDate: Date = new Date();
        let isCurrentMonth: boolean = false;
        if (validValueItem === DataRangesEnum.Current) // current month
        {
            startDate = new Date(date.getFullYear(), date.getMonth(), 1);
            endDate = new Date();
            isCurrentMonth = true;
            return {startDate, endDate, isCurrentMonth};
        }
        if (validValueItem === DataRangesEnum.Yesterday) // Yesterday
        {
            startDate = new Date(date.getFullYear(), date.getMonth(), date.getDate() - 1);
            endDate = new Date(date.getFullYear(), date.getMonth(), date.getDate() - 1, 23, 59, 59, 999);
            isCurrentMonth = startDate.getMonth() === date.getMonth();
            return {startDate, endDate, isCurrentMonth};
        }
        if (validValueItem === DataRangesEnum.LastMonth) // Last month
        {
            startDate = new Date(date.getFullYear(), date.getMonth() - 1, 1);
            endDate = new Date(date.getFullYear(), date.getMonth() , 0);
            return {startDate, endDate, isCurrentMonth};
        }
        if (validValueItem === DataRangesEnum.PreviousMonth) // Previous Month
        {
            startDate = new Date(date.getFullYear(), date.getMonth() - 2, 1);
            endDate = new Date(date.getFullYear(), date.getMonth() - 1, 0);
            return {startDate, endDate, isCurrentMonth};
        }
        if (validValueItem === DataRangesEnum.LastYear_MTD) // Last Year (MTD)
        {
            startDate = new Date(date.getFullYear() - 1, date.getMonth(), 1);
            endDate = new Date(date.getFullYear() - 1, date.getMonth(), date.getDate());
            return {startDate, endDate, isCurrentMonth};
        }
        if (validValueItem === DataRangesEnum.CurrentQuarter) // Current Quarter
        {
            startDate = new Date(date.getFullYear() , 3 * currQuarter - 3 , 1);
            endDate = new Date(date.getFullYear() , 3 * currQuarter  , 0);
            return {startDate, endDate, isCurrentMonth};
        }
        if (validValueItem === DataRangesEnum.LastQuarter) // Last Quarter
        {
            startDate = new Date(date.getFullYear() , 3 * (currQuarter - 1) - 3 , 1);
            endDate = new Date(date.getFullYear() , 3 * (currQuarter - 1) , 0);
            return {startDate, endDate, isCurrentMonth};
        }
        if (validValueItem === DataRangesEnum.PreviousQuarter) // Previous Quarter
        {
            startDate = new Date(date.getFullYear() , 3 * (currQuarter - 2) - 3 , 1);
            endDate = new Date(date.getFullYear() , 3 * (currQuarter - 2)   , 0);
            return {startDate, endDate, isCurrentMonth};
        }
        if (validValueItem === DataRangesEnum.LastYearQTD) // Last Year QTD
        {
            startDate = new Date(date.getFullYear() - 1 , 3 * currQuarter - 3 , 1);
            endDate = new Date(date.getFullYear() - 1, date.getMonth(), date.getDate());
            return {startDate, endDate, isCurrentMonth};
        }
        if (validValueItem === DataRangesEnum.CurrentYear) // Current Year
        {
            startDate = new Date(date.getFullYear(), 0, 1);
            endDate = new Date();
            return {startDate, endDate, isCurrentMonth};
        }
        if (validValueItem === DataRangesEnum.LastYear) // Last Year
        {
            startDate = new Date(date.getFullYear() - 1 , 0, 1);
            endDate = new Date(date.getFullYear() - 1, 12, 0);
            return {startDate, endDate, isCurrentMonth};
        }
        if (validValueItem === DataRangesEnum.PreviousYear) // Previous Year
        {
            startDate = new Date(date.getFullYear() - 2 , 0, 1);
            endDate = new Date(date.getFullYear() - 2, 12, 0);
            return {startDate, endDate, isCurrentMonth};
        }
        if (validValueItem === DataRangesEnum.LastYearYTD) // Last Year YTD
        {
            startDate = new Date(date.getFullYear() - 1 , 0, 1);
            endDate = new Date(date.getFullYear() - 1, date.getMonth(), date.getDate());
            return {startDate, endDate, isCurrentMonth};
        }
        if (validValueItem === DataRangesEnum.LIfeTime) // LIfeTime
        {
            startDate = new Date('01/01/1990');
            endDate = new Date();
            return {startDate, endDate, isCurrentMonth};
        }
        else {
            return {startDate, endDate, isCurrentMonth};
        }

    }

    static saveExcelFile(buffer: any, fileName: string): void {
        const data: Blob = new Blob([buffer], { type: 'application/octet-stream' });
        const url: string = window.URL.createObjectURL(data);
        const a: HTMLAnchorElement = document.createElement('a');
        a.href = url;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);
    }

    static  getDifferenceInMinutes(startDate: Date, endDate: Date): number {
        const diffInMilliseconds = endDate.getTime() - startDate.getTime();
        const diffInMinutes = Math.floor(diffInMilliseconds / (1000 * 60)); // Convert milliseconds to minutes
        return diffInMinutes;
    }

}
